import*as e from"react";export function usePrevious(r){const t=e.useRef(r);return e.useEffect((()=>{t.current=r}),[r]),t.current}
//# sourceMappingURL=index.module.js.map
